import React from "react";
import { Field } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import CustomDatePickerComponent from "components/Form/CustomDatePickerComponent";
import RadioButtons from "components/Form/RadioButtons";
import Select from "components/Form/Select";
import { Checkbox } from "components/Form/SpecialButtons";

const GeneralForm = ({ element, errors, touched, nurses, values }) => {
	return (
		<div>
			<RadioButtons
				name="gender"
				field1={{ id: "m", customlabel: "Homme" }}
				field2={{ id: "f", customlabel: "Femme" }}
				customlabel="Genre"
				errors={errors}
				touched={touched}
				required
			/>

			<Field type="text" name="last_name" customlabel="Nom" component={CustomInputTextComponent} required forceUpperCase />
			<Field type="text" name="first_name" customlabel="Prénom(s)" component={CustomInputTextComponent} required forceCapitalize />
			<Field type="text" name="email" customlabel="Email" component={CustomInputTextComponent} required />
			<Field type="text" name="login" customlabel="Login" component={CustomInputTextComponent} required />
			<Field type="password" name="password" customlabel="Mot de passe" component={CustomInputTextComponent} />
			<Field type="password" name="repassword" customlabel="Confirmer le mot de passe" component={CustomInputTextComponent} />
			<Field
				id="resetPassword"
				name="resetPassword"
				customlabel="Saisir un nouveau mot de passe lors de la prochaine connexion"
				component={Checkbox}
			/>
			<Field id="expiration_date" name="expiration_date" customlabel="Date d'expiration du compte" component={CustomDatePickerComponent} />
			<Field type="text" name="comment" customlabel="Commentaire" component={CustomInputTextComponent} />
			<Field type="text" name="sampler_code" customlabel="Code SIL" component={CustomInputTextComponent} />
		</div>
	);
};

export default GeneralForm;
